import React from 'react';
import LateralMenu from '../LateralMenu';
import { translate } from '../../services/translate';
import collapsedLogo from '../../../assets/icon_cloned_plate.png';
import { faCar, faClipboard } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../assets/logo_cloned_plate.png';

export default function ClonedPlateLateralMenu({ navigation, authenticatedUser, open, setOpen, selectedMenu }: LateralMenuProps) {
    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            items={[{
                icon: faCar,
                text: translate('clonedPlates'),
                action: () => navigation.navigate('ClonedPlate', { screen: 'ClonedPlates' }),
                selected: selectedMenu == 'cloned-plates',
                omit: !authenticatedUser?.isAdmin && !authenticatedUser?.permissions.cloned_plate_module_access,
            }, {
                icon: faClipboard,
                text: translate('cloneSuspicions'),
                action: () => navigation.navigate('ClonedPlate', { screen: 'CloneSuspicions' }),
                selected: selectedMenu == 'clone-suspicions',
                omit: !authenticatedUser?.isAdmin && !authenticatedUser?.permissions.cloned_plate_module_access,
            }]}
        />
    );
}
